"use client";

import NextError from "next/error";
import posthog from "posthog-js";
import { useEffect } from "react";

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    console.error("Global error:", error);

    posthog.capture("global_error_occurred", {
      error_message: error.message,
      error_name: error.name,
      error_digest: error.digest,
      error_stack: error.stack,
    });

    posthog.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body>
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
